// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"33a31884","239":"9d4b07f5","453":"e6c50e8d","732":"7f499a09"}[chunkId] + ".chunk.js";
};